import api from '../api';

// Create Overtime for current user
export async function createMyOvertime(overtimeData) {
  try {
    const response = await api.post('/over-time/me', overtimeData);
    return response.data;
  } catch (error) {
    console.error('Error creating overtime:', error);
    throw error;
  }
}

// Get all overtimes for the current user
export async function getMyOvertimes() {
  try {
    const response = await api.get('/over-time/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching my overtimes:', error);
    throw error;
  }
}

// Update own overtime (only if unconfirmed)
export async function updateMyOvertime(id, overtimeData) {
  try {
    const response = await api.put(`/over-time/me/${id}`, overtimeData);
    return response.data;
  } catch (error) {
    console.error('Error updating overtime:', error);
    throw error;
  }
}

// Delete own overtime (only if unconfirmed)
export async function deleteMyOvertime(id) {
  try {
    const response = await api.delete(`/over-time/me/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting overtime:', error);
    throw error;
  }
}

// Get all overtimes (for HR/Manager)
export async function getAllOvertimes() {
  try {
    const response = await api.get('/over-time');
    return response.data;
  } catch (error) {
    console.error('Error fetching all overtimes:', error);
    throw error;
  }
}

// Confirm/Reject an overtime record (HR/Manager)
export async function confirmOvertime(id, confirmed) {
  try {
    const response = await api.put(`/over-time/${id}/confirm`, { confirmed });
    return response.data;
  } catch (error) {
    console.error('Error confirming overtime:', error);
    throw error;
  }
}

// Unconfirm an overtime record (Reject/Undo)
export async function unconfirmOvertime(id) {
  try {
    const response = await api.put(`/over-time/${id}/unconfirm`);
    return response.data;
  } catch (error) {
    console.error('Error unconfirming overtime:', error);
    throw error;
  }
}
